import PropTypes from "prop-types";
import { Chakra } from "@airhelp/react-ui-components";
import { AirhelpLogo } from "styles/logos";
import { DownloadIcon } from "styles/icons";

const { Box, Text, AspectRatio, Image, Link } = Chakra;

const PressAssetItem = ({ href, image, title }) => (
  <Link href={href} _hover={{ textDecor: "none" }}>
    <AspectRatio ratio={19 / 12} mb={4}>
      {image ? (
        <Image src={image} title={title} rounded="xl" />
      ) : (
        <Box bgColor="primary.900" rounded="xl">
          <AirhelpLogo boxSize={40} color="white" />
        </Box>
      )}
    </AspectRatio>
    <Text mb={2} color="primary.900" fontWeight="bold" fontSize="xl" lineHeight="1.2">
      {title} <DownloadIcon ml={1} />
    </Text>
  </Link>
);

export default PressAssetItem;

PressAssetItem.propTypes = {
  href: PropTypes.string.isRequired,
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
};

PressAssetItem.defaultProps = {
  image: undefined,
};
